


























































































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import moment from "moment";
import { Validator } from "vee-validate";
import { useUtilityStore } from "@/admin/store/utility";

@Component({
  components: { }
})
export default class PasswordRest extends Vue {
  $validator: Validator;

  utilityStore = useUtilityStore();

  userEmail = "";
  expirationTime = "";
  newPassword = "";
  didSendRequest = false;

  emailBlurred () {
    this.$validator.validateAll();
  }

  resetClicked () {
    this.$validator.validateAll()
      .then(isValid => {
        if (!isValid) {
          return;
        }

        this.didSendRequest = true;
        return this.utilityStore.resetPassword(this.userEmail);
      })
      .then((data: any) => {
        if (!data) {
          this.didSendRequest = false;
          return;
        }

        this.expirationTime = moment().add(15, "minutes").format("HH:mm:ss");
        this.newPassword = data.password;
      });
  }
}
